.bulk-update-wrapper {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}

.bulk-update-item {
  padding-left: 10px;
}
